import { Stack } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import {
  GridToolbarColumnsButton,
  GridToolbarProps,
  GridToolbarResetButton,
  GridToolbarSearch,
} from '../../../../components/data-grid';
import { IssuesGridToolbarAddIssue } from './issues-grid-toolbar-add-issue';

export function IssuesGridToolbar(props: GridToolbarProps) {
  const { columns } = props;

  return (
    <GridToolbarContainer>
      <GridToolbarSearch />
      <GridToolbarColumnsButton columns={columns} />
      <GridToolbarResetButton />
      <Stack direction='row' flex={1} justifyContent='flex-end' spacing={1}>
        <IssuesGridToolbarAddIssue />
      </Stack>
    </GridToolbarContainer>
  );
}
